module.exports = __webpack_public_path__ + "al.a07d2864ae4158649c50.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/al.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/al.svg
// module chunks = styles